import { AudioVisualizer } from "../AudioVisualizer";
import { customBlue, customGrey } from "../../theme/palette";

interface RecordingMicCheckStateProps {
  onCancel: () => void;
  onRetry: () => void;
  onStop?: () => void;
  onAudioDetected?: (detected: boolean) => void;
  liveRecordingFrequencyLevel: number;
  audioDetected: boolean;
}

export function RecordingMicCheckState({
  onStop,
  liveRecordingFrequencyLevel,
  audioDetected,
}: RecordingMicCheckStateProps) {
  const buttonColor = audioDetected
    ? customBlue.primaryBlue
    : customGrey.iconGrade;
  const recordButtonWidth = 70;
  const recordButtonHeight = 70;

  return (
    <AudioVisualizer
      frequencyLevel={liveRecordingFrequencyLevel}
      color={buttonColor}
      buttonSize="medium"
      buttonWidth={recordButtonWidth}
      buttonHeight={recordButtonHeight}
      onStop={onStop}
      disabled={!audioDetected}
      outerPadding={6}
      innerPadding={4}
    />
  );
}
